import type { Workspace } from "../api/workspaces";

/**
 * Sort workspaces alphabetically by name while keeping archived entries after active ones.
 * Falls back to created_at to stabilize ordering when names match.
 */
export function sortWorkspacesByName(workspaces: Workspace[]): Workspace[] {
  const list = Array.isArray(workspaces) ? workspaces : [];

  return [...list].sort((a, b) => {
    const aArchived = Boolean(a.archived_at);
    const bArchived = Boolean(b.archived_at);

    if (aArchived !== bArchived) {
      return Number(aArchived) - Number(bArchived);
    }

    const nameCompare = (a.name ?? "").localeCompare(b.name ?? "", undefined, {
      sensitivity: "base",
      numeric: true,
    });

    if (nameCompare !== 0) {
      return nameCompare;
    }

    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
}
